var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49084 0.937746C5.50412 0.937746 3.59859 1.72692 2.19403 3.13178C0.789288 4.53668 0 6.44205 0 8.42859C0 12.8088 4.10306 18.0516 6.23504 20.4964H6.23519C6.55251 20.8562 7.00905 21.0624 7.4889 21.0624C7.96859 21.0624 8.42531 20.8562 8.74261 20.4964C10.879 18.0649 15 12.8222 15 8.42859C15 7.11159 14.6527 5.81784 13.9933 4.67788C13.334 3.5378 12.3858 2.59178 11.2441 1.93517C10.1026 1.27855 8.80813 0.934319 7.49117 0.937522L7.49084 0.937746ZM7.49084 12.7106C6.35527 12.7106 5.26611 12.2596 4.46312 11.4566C3.66013 10.6536 3.20896 9.56441 3.20896 8.42885C3.20896 7.29313 3.66013 6.20412 4.46312 5.40113C5.26611 4.59813 6.35527 4.14697 7.49084 4.14697C8.62641 4.14697 9.71556 4.59813 10.5186 5.40113C11.3216 6.20412 11.7727 7.29313 11.7727 8.42885C11.7727 9.56441 11.3216 10.6536 10.5186 11.4566C9.71556 12.2596 8.62641 12.7106 7.49084 12.7106Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.364e327989203811a7fad1aaacd4e10f.svg";
export { ForwardRef as ReactComponent };